// Imports
import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import { Routes, Route, Navigate } from 'react-router-dom';

// Views
import DriverPerformanceMainView from "../../modules/driverPerformance/views/main";
import DriverPerformanceDetailView from "./views/caseDetail";
import DriverPerformanceDetailDriverView from "./views/driverDetail";
import DriverPerformanceConfigurationView from "./views/configurationDetail";

//Security
import { HasPermission } from "Core/security";

// Router
const RouterDriverPerformanceViews = (props) => {
  const { match } = props;
  const user = useSelector((state) => state.securityRedux.user);

  return (
    <Routes>
      {
        HasPermission(user, ['driverPer'], [316]) && (
          <Fragment>
            <Route path='/' element={<Navigate to="/app/driverPerformance/main" />}></Route>
            <Route path='main' element={<DriverPerformanceMainView />} />
            <Route path='caseDetail/:id' element={<DriverPerformanceDetailView />} />
            <Route path='driverDetail/:id' element={<DriverPerformanceDetailDriverView />} />
            {HasPermission(user, 'drpconf', [326]) && <Route path='configurationDetail' element={<DriverPerformanceConfigurationView />} />}
          </Fragment>
        )
      }
      <Route path="*" element={<Navigate to="/app/error" />} />
    </Routes>
  );
};

export default RouterDriverPerformanceViews;
